import SignUp from '../../components/uicontainers/public/signup';

export default function SignUpPage() {
  return (
    <>
      <SignUp />
    </>
  );
}
